import { render, staticRenderFns } from "./SchoolBestStudents.vue?vue&type=template&id=4eaf709e"
import script from "./SchoolBestStudents.vue?vue&type=script&lang=js"
export * from "./SchoolBestStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports